import React, { Component} from 'react';
import {Container, Card, CardHeader, CardBody, CardFooter, Breadcrumb, BreadcrumbItem} from 'reactstrap';
import axios from 'axios';
import Cookies from 'universal-cookie';

const cookies = new Cookies();
const prebase = window.location.protocol + '//' + window.location.host;
const base = (prebase.indexOf('3000') > -1) ? prebase.replace('3000', '8080') : prebase;

export default class LocationList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            locations: [],
        };
        this.loadLocations();
    }
    
    loadLocations() {
        let authToken = cookies.get('auth_token')
        axios({
            method: 'get',
            url: `${base}/api/caregivers/locations/`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${authToken}`
            },
            withCredentials: true,
        }).then(response => {
            this.setState({
                locations: response.data,
            })
        }).catch(error => {
            console.log(error);
        })
    }

    render() {
        return (
            <Container>
                <Card>
                    <CardHeader>
                        <h2 className="float-left">Locations</h2>
                        <a className="mui-btn mui-btn--raised float-right" href="/admin/locations/new">Add Location</a>
                    </CardHeader>
                    <CardBody>
                        {this.state.locations.map((loc) => (
                            <a key={loc.pk} href={`/admin/locations/${loc.pk}/view`}>
                                <Card key={loc.pk}> 
                                    <CardBody>
                                    <p className="h4 float-left">{loc.Name}</p>
                                    <p className="h5 float-right">{`${loc.Address} ${loc.City}, ${loc.State} ${loc.ZipCode}`}</p>
                                    </CardBody>
                                </Card>
                            </a>
                        ))}
                    </CardBody>
                    <CardFooter>
                    </CardFooter>
                </Card>
            </Container>
        )
    }
}

